import debounce from 'lodash/debounce';
import React from 'react';
import './RecordingVolumeSlider.css';

type MiniSliderProps = {
  minVal?: number;
  maxVal?: number;
  val: number;
  onChange: (volume: number) => void;
  labelText?: string;
  disabled?: boolean;
  vertical?: boolean;
};

const MiniSlider: React.FC<MiniSliderProps> = ({
  minVal,
  maxVal,
  val,
  onChange,
  labelText,
  disabled,
  vertical,
}: MiniSliderProps) => {
  const onChangeDebounced = React.useCallback(debounce(onChange, 50, { trailing: true }), [onChange]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = parseInt(e.target.value);
    onChangeDebounced(val);
  };

  return (
    <div className={vertical ? 'slider-container-vertical' : 'slider-container'}>
      <input
        title={labelText}
        disabled={disabled}
        min={minVal ? minVal : 0}
        max={maxVal ? maxVal : 100}
        onChange={handleChange}
        step={1}
        type='range'
        value={val}
      />
    </div>
  );
};

export default MiniSlider;
